import {
  HeaderWrapper,
  AuthorDataWrapper,
  ArticleDataWrapper,
} from '@web/newsfeed/Article/ArticleHeader/articleHeader.styles';
import {
  SearchArticleWrapper,
  SearchItemWrapper,
} from '@web/newsfeed/ArticleSearch/ArticleSearchItem/articleSearchItem.styles';
import { ContentWrapper } from '@web/components/SearchContentPreview/searchContentPreview.styles';
import { ArticleDateSkeleton } from '@web/newsfeed/ArticleSearch/ArticleSearchSkeleton/components/ArticleDateSkeleton';

import { AuthorDataSkeleton } from './components/AuthorDataSkeleton';
import { ArticleContentSkeleton } from './components/ArticleContentSkeleton';

export const ArticleSearchSkeleton = () => {
  return (
    <SearchItemWrapper data-testid="article-skeleton">
      <SearchArticleWrapper>
        <HeaderWrapper>
          <AuthorDataWrapper>
            <AuthorDataSkeleton />
          </AuthorDataWrapper>
          <ArticleDataWrapper>
            <ArticleDateSkeleton />
          </ArticleDataWrapper>
        </HeaderWrapper>
        <ContentWrapper maskEnabled={false} contentHeight={80}>
          <ArticleContentSkeleton />
        </ContentWrapper>
      </SearchArticleWrapper>
    </SearchItemWrapper>
  );
};
